import React from 'react'
import './Background.css'

function Background () {
  return (
    <div className="bg-container">
      <div className="bg-color colorpink"></div>
      <div className="bg-color colorpurple"></div>
      <div className="bg-color colorteal"></div>
      <div className="bg-color colorblue"></div>
    </div>
  )
}

export default Background
